const scrollTo = (px?: number) => {
	document.body.scrollTop = px ?? 0
	document.documentElement.scrollTop = px ?? 0
}

export default scrollTo
